import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.ViajeRutaDto;
type Column = kea.Grid2Column<Entity>;

const columnasFijas: Column[] = [
    { title: "Folio", cell: x => ({ data: x.Folio }) },
    { title: "Camión", cell: x => ({ data: x.NombreCamion }) },
    { title: "Origen", cell: x => ({ data: x.NombreSucursalOrigen }) },
    { title: "Destino", cell: x => ({ data: x.NombreSucursalDestinio }) },
    { title: "Status", cell: x => ({ data: models.StatusViajeRuta[x.Status] }) },
    { title: "Chofer", cell: x => ({ data: x.NombreChofer }) },
    { title: "Fecha de creación", cell: x => ({ data: kea.toDate(x.FechaCreacion) }) },
    { title: "Fecha de salida", cell: x => ({ data: kea.toDate(x.FechaRealSalida) }) },
    { title: "Fecha de llegada", cell: x => ({ data: kea.toDate(x.FechaRealLlegada) }) },
    { title: "Fecha y hora estimada de llegada", cell: x => ({ data: kea.toDate(x.HoraEstimadaLlegada) }) },
]

interface Deps {
    onDarSalida: (x: models.ViajeRutaDto) => void;
    onDarLlegada: (x: models.ViajeRutaDto) => void;
    onCancelarViaje: (x: models.ViajeRutaDto) => void;
    onImprimirManifiesto: (x: models.ViajeRutaDto) => void;
    onTimbrarCartaPorte: (x: models.ViajeRutaDto) => void;
    onImprimirCartaPorte: (x: models.ViajeRutaDto) => void;
}

export function columnas(deps: Deps, HabilitarValidacionesCartaPorte: boolean): Column[] {
    const botones = kea.columnaBotones<Entity>([
        {
            iconClass: fa("paper-plane-o"),
            tooltip: "Dar salida",
            style: "success",
            disabled: x => 
            (!(x.Status == models.StatusViajeRuta.Creado ))
            || 
            (HabilitarValidacionesCartaPorte ? !(x.TieneXmlCartaPorteTimbrado && x.TienexmlImpreso) : false),
            onClick: deps.onDarSalida
        },
        {
            iconClass: fa("bus"),
            tooltip: "Dar llegada",
            style: "info",
            disabled: x => x.Status != models.StatusViajeRuta.EnTrayecto,
            onClick: deps.onDarLlegada
        }, {
            iconClass: fa("times"),
            tooltip: "Cancelar",
            style: "danger",
            disabled: x => x.Status != models.StatusViajeRuta.Creado,
            onClick: deps.onCancelarViaje
        }, 
        
            {
                iconClass: fa("print"),
                tooltip: "Imprimir manifiesto",
                style: "default",
                disabled: x => x.Status == models.StatusViajeRuta.Creado || x.Status == models.StatusViajeRuta.Cancelado,
                onClick: deps.onImprimirManifiesto,
            },
        
        {
            iconClass: fa("bell"),
            tooltip: "Timbrar Carta Porte",
            style: "default",
            onClick: deps.onTimbrarCartaPorte,
            //disabled: x => x.Status != models.StatusViajeRuta.Creado,
        },{
            iconClass: fa("print"),
            tooltip: "Imprimir carta porte timbrada",
            style: "default",
            onClick: deps.onImprimirCartaPorte,
            disabled: x => !(x.TieneXmlCartaPorteTimbrado),
        }
    ]);

    return [botones, ...columnasFijas];
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/viajes/list/columns.tsx